import { type FC } from 'react'

import { useLocales } from '@/shared/hooks/useLocales'

interface RecaptchaFooterProps {
  className?: string
}

const RecaptchaFooter: FC<RecaptchaFooterProps> = ({ className }) => {
  const { isLocale } = useLocales()

  if (!isLocale.KR) {
    return null
  }

  return (
    <div className="absolute bottom-0 left-0 right-0 p-3 text-center text-xs text-gray-500 leading-[1.4] bg-white border-t border-gray-200 z-10">
      이 사이트는{' '}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-800 underline hover:text-gray-800"
      >
        reCAPTCHA로 보호
      </a>
      되며, Google{' '}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-800 underline hover:text-gray-800"
      >
        개인정보처리방침
      </a>
      과{' '}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-800 underline hover:text-gray-800"
      >
        서비스 약관
      </a>
      이 적용됩니다.
    </div>
  )
}

export default RecaptchaFooter
